module.exports = {"331024001":"安洲街道","331024002":"南峰街道","331024003":"福应街道","331024101":"横溪镇","331024102":"埠头镇","331024103":"白塔镇","331024104":"田市镇","331024105":"官路镇","331024106":"下各镇","331024107":"朱溪镇","331024200":"安岭乡","331024201":"溪港乡","331024202":"湫山乡","331024203":"淡竹乡","331024204":"皤滩乡","331024205":"上张乡","331024206":"步路乡","331024207":"广度乡","331024209":"大战乡","331024210":"双庙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331024.json
// module id = 1125
// module chunks = 0